import { Button } from "../_helpers/components/Button";
import { Alert } from "../../components/_helpers/Alert";
import { getUserInfo } from "../../components/_api/Admin";
import { setupIntent, addPaymentMethod } from "../../components/_api/Stripe";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

export const PaymentMethod = (props) => {
    const { user, setUser, features_right } = props;

    const [intent, setIntent] = useState(null);
    const [isAddingPayment, setIsAddingPayment] = useState(false);

    const setupPayment = () => {
        setupIntent()
            .then((resp) => {
                setIsAddingPayment(true);
                setIntent(resp.data);
                setTimeout(() => {
                    const stripe = Stripe(process.env.REACT_STRIPE_KEY);
                    const elements = stripe.elements();
                    const cardElement = elements.create("card");
                    cardElement.mount("#card-element");
                    const cardHolderName =
                        document.getElementById("card-holder-name");
                    const cardButton = document.getElementById("card-button");
                    const clientSecret = cardButton.dataset.secret;

                    cardButton.addEventListener("click", async (e) => {
                        const { setupIntent, error } =
                            await stripe.confirmCardSetup(clientSecret, {
                                payment_method: {
                                    card: cardElement,
                                    billing_details: {
                                        name: cardHolderName.value,
                                    },
                                },
                            });

                        if (error) {
                            console.log(error);
                            toast(error.message);
                        } else {
                            setIsAddingPayment(false);
                            addPaymentMethod({
                                payment_method: setupIntent.payment_method,
                            }).then(async (resp) => {
                                console.log(resp);
                                setUser(await getUser());
                                toast("Votre moyen de paiement a été ajouté");
                            });
                        }
                    });
                }, "1000");
            })
            .catch((resp) => {
                console.log(resp);
            });
    };

    async function getUser() {
        const user = await getUserInfo();
        return user.data;
    }

    return (
        <div>
            {user && !isAddingPayment && (
                <div className="flex justify-between">
                    <Alert
                        title={"Votre moyen de paiement est pris en compte"
                        }
                        message={`Vous êtes actuellement en période d'essai jusqu'au`}
                    />

                    <Button
                        action={() => {
                            setupPayment();
                        }}
                        name={
                            "Ajouter un moyen de paiement"
                        }
                        type={"empty"}
                        isVisible={
                            features_right["add_payment"]
                        }
                    />
                </div>
            )}
            {isAddingPayment && (
                <div className=" w-1/3">
                    <div className="border-2 border-app-primary p-3">
                        <p className="">
                            Remplissez vos informations de cartes
                        </p>
                        <input
                            id="card-holder-name"
                            type="text"
                            placeholder="Nom de la carte"
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded-sm py-2 px-3 mb-3 leading-tight focus:outline-hidden focus:bg-white"
                        />

                        <div
                            id="card-element"
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded-sm py-2 px-3 mb-3 leading-tight focus:outline-hidden focus:bg-white"
                        ></div>
                        <div className="text-right">
                            <Button
                                id="card-button"
                                data-secret={intent.client_secret}
                                name={"Enregistrer ce moyen de paiement"}
                                type={"empty"}
                            />
                        </div>
                    </div>

                    {/* <button
                id="card-button"
                data-secret="{{ $intent->client_secret }}"
                onClick={() => savePaymentMethod()}
            ></button> */}
                </div>
            )}
        </div>
    );
};
